import { Component, Host, h, Element } from "@stencil/core";

/**
 * @slot (default) - primary buttons, shown on the right side of the footer
 * @slot secondary - secondary buttons, shown on the left side of the footer
 */
@Component({
    tag: "uic-footer",
    styleUrl: "footer.scss",
})
export class Footer {
    @Element() host: HTMLUicFooterElement;

    componentDidLoad() {
        this.setButtonVariants();
    }

    private getFooterButtons() {
        return [
            [
                ...this.host.querySelectorAll<HTMLUicButtonElement>(
                    `uic-button:not([slot="secondary"]), [slot]:not([slot="secondary"]) uic-button`
                ),
            ],
            [
                ...this.host.querySelectorAll<HTMLUicButtonElement>(
                    `uic-button[slot=secondary], [slot="secondary"] uic-button`
                ),
            ],
        ];
    }

    private setButtonVariants() {
        let [primaryButtons, secondaryButtons] = this.getFooterButtons();

        secondaryButtons.forEach((e) => {
            if (
                e != null &&
                e.variant !== undefined &&
                !e.variant.includes("footer")
            ) {
                e.variant = "footer";
            }
        });

        primaryButtons.forEach((e, idx) => {
            if (e.variant === undefined) {
                e = e.querySelector("uic-button");
            }

            if (
                e != null &&
                e.variant !== undefined &&
                !e.variant.includes("footer")
            ) {
                const buttonVariant =
                    idx === primaryButtons.length - 1 ||
                    secondaryButtons.length > 0
                        ? "footer-primary"
                        : "footer";
                e.variant = buttonVariant;
            }
        });
    }

    render() {
        return (
            <Host>
                <div class="uic-footer__container">
                    <slot name="secondary"></slot>
                </div>
                <div class="uic-footer__container">
                    <slot></slot>
                </div>
            </Host>
        );
    }
}
